<vw-toast-popup [isOpen]="isOpen" width="100%" borderRadius="20px" paddingTop="15%" (close)="onClose()" [toastCustomClass]="'mx-2'">
  <div class="flex flex-col gap-4 mx-4 mt-6 mb-8 max-h-[70vh] overflow-y-auto">
    <div class="flex items-center justify-center gap-2">
      <p class="text-lg font-bold">{{ 'calendar.climate.picker.title' | translate }}</p>
      <button (click)="infoClick.emit(); onClose()" type="button" class="text-grey-400 hover:text-grey-600">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </button>
    </div>

    <!-- Mon climat (option de reset) -->
    <div
      class="flex items-center gap-3 rounded-full p-2 px-4 cursor-pointer"
      [ngClass]="selectedClimateType === null ? 'bg-grey-50 border-2 border-primary' : 'bg-grey-50'"
      (click)="selectClimate(null)">
      <span class="text-sm font-medium text-grey-700 flex-1">
        {{ myClimateType ? ('profile.addresses.climate-types.' + myClimateType | translate) : ('calendar.climate.myClimate' | translate) }}
        <span class="text-xs text-grey-400 font-normal ml-1">({{ 'calendar.climate.myClimate' | translate }})</span>
      </span>
      @if (selectedClimateType === null) {
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/>
        </svg>
      }
    </div>

    <!-- Groupes de climat -->
    @for (group of groups; track group.key) {
      <div>
        <p class="text-xs font-semibold text-grey-400 uppercase px-2 mb-2">
          {{ group.emoji }} {{ getFamilyLabel(group.key) }}
        </p>
        <div class="flex flex-col gap-2">
          @for (climate of group.climates; track climate.climateType) {
            <div
              class="flex items-center gap-3 rounded-full p-2 px-4 cursor-pointer"
              [ngClass]="selectedClimateType === climate.climateType ? 'bg-grey-50 border-2 border-primary' : 'bg-grey-50'"
              (click)="selectClimate(climate.climateType)">
              <span class="text-sm text-grey-700 flex-1">{{ 'profile.addresses.climate-types.' + climate.climateType | translate }}</span>
              <span class="text-xs text-grey-400">{{ climate.cultivationCount }} cultures</span>
              @if (selectedClimateType === climate.climateType) {
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/>
                </svg>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
</vw-toast-popup>
